// @flow
import React, { Component } from 'react';
import { XSvg, XWrapperDiv, CalendarClosedP } from './CalendarStyles';
import { formatDate } from '../../utilities/misc';

type Props = {
  calendarStart?: string,
  calendarEnd?: string,
  clearCalendarFilter: () => void,
  disabled?: boolean
};

export default class CalendarClosed extends Component<Props> {
  handleClick = (e: SyntheticMouseEvent<HTMLAnchorElement>) => {
    if (this.props.disabled) return;
    e.stopPropagation();
    this.props.clearCalendarFilter();
  };
  render() {
    return (
      <>
        <CalendarClosedP>
          {formatDate(this.props.calendarStart || '')} -{' '}
          {formatDate(this.props.calendarEnd || '')}
        </CalendarClosedP>
        <XWrapperDiv onClick={this.handleClick}>
          <XSvg disabled={this.props.disabled} />
        </XWrapperDiv>
      </>
    );
  }
}
